module.exports = __webpack_public_path__ + "img/guide3.d25910c6.png";